import React from "react";
import { Link } from "react-router-dom";

const CONTACT_EMAIL = "contato@kosmosai.com.br";

export default function TermosDeUso() {
  return (
    <div className="min-h-screen bg-[#F4F7FB]">
      <header className="sticky top-0 z-50 border-b border-[#D1DEEE] bg-white">
        <div className="mx-auto flex h-16 max-w-4xl items-center justify-between px-6">
          <Link to="/" data-testid="terms-home-link" aria-label="Voltar para a página inicial do TUTO">
            <img src="/logo-tuto.png" alt="TUTO by Kosmos" className="h-8 w-auto" />
          </Link>
          <Link
            to="/"
            data-testid="terms-back-link"
            className="text-sm font-medium text-[#335480] transition-colors hover:text-[#003882]"
          >
            Voltar ao início
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-12 md:py-16">
        <article className="border border-[#D1DEEE] bg-white p-6 md:p-10">
          <div className="mb-10 border-b border-[#D1DEEE] pb-8">
            <p className="mb-3 text-sm font-medium text-[#335480]">Documentos legais</p>
            <h1 className="mb-4 text-4xl font-bold text-[#001533]" style={{ fontFamily: "Cabinet Grotesk" }}>
              Termos de Uso
            </h1>
            <p className="text-sm text-[#335480]">Vigência: 28 de agosto de 2026 · Versão 1.2</p>
          </div>

          <div className="max-w-[72ch] space-y-9 text-base leading-7 text-[#335480]">
            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">1. Quem somos e como estes Termos funcionam</h2>
              <p>
                O TUTO é uma plataforma web de inteligência processual oferecida pela <strong>Keep Soluções Tecnológicas Ltda.</strong>,
                CNPJ 08.277.372/0001-71, identificada no produto como “TUTO by KOSMOS”. Estes Termos regulam o acesso
                à plataforma, aos recursos de monitoramento processual, agenda, tarefas, notificações, integrações e planos.
              </p>
              <p className="mt-3">
                Ao criar uma conta, receber um convite ou usar o TUTO, você declara que leu e concorda com estes Termos e
                com a <Link to="/politica-de-privacidade" data-testid="terms-privacy-link" className="font-medium text-[#003882] hover:text-[#00285e]">Política de Privacidade</Link>.
                Se você utiliza o TUTO em nome de um escritório, declara ter poderes para vincular esse escritório a estes Termos.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">2. O que o TUTO entrega</h2>
              <p>
                O TUTO organiza informações disponibilizadas por fontes compatíveis, como DataJud, DJEN e integrações
                processuais, para apoiar a rotina do escritório. A plataforma também permite cadastrar OABs e processos,
                acompanhar movimentações e publicações, organizar agenda e tarefas, receber alertas e convidar membros da equipe.
              </p>
              <p className="mt-3">
                O TUTO é uma ferramenta de apoio operacional. Ele não substitui os canais oficiais da Justiça, não presta
                aconselhamento jurídico e não realiza a conferência profissional exigida para a gestão de prazos e processos.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">3. Conta, workspace e acesso</h2>
              <ul className="list-disc space-y-2 pl-6">
                <li>O acesso pode ser feito por e-mail e senha ou pela conta Google, quando essa opção estiver disponível.</li>
                <li>Você deve fornecer dados corretos, manter sua senha sob sigilo e comunicar qualquer uso não autorizado da conta.</li>
                <li>Uma conta pode integrar um workspace. O proprietário do workspace administra o nome do escritório, convites, plano e recursos compartilhados.</li>
                <li>Convites devem ser enviados somente a pessoas autorizadas a acessar os dados do escritório.</li>
                <li>O TUTO pode limitar, suspender ou encerrar acessos usados em desconformidade com estes Termos, a lei ou a segurança da plataforma.</li>
              </ul>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">4. Planos, cobrança e cancelamento</h2>
              <p>
                O plano FREE é gratuito e sujeito aos limites exibidos no produto. Os planos PRO, recursos incluídos,
                preços, periodicidade e eventuais condições comerciais são os apresentados na página de planos no momento da contratação.
              </p>
              <p className="mt-3">
                A assinatura PRO é recorrente e o pagamento é processado pela Stripe. Os dados completos do cartão são
                tratados no ambiente da Stripe, não no TUTO. O titular da assinatura pode gerenciar ou cancelar a renovação
                pelo portal de cobrança disponibilizado no produto. Após um cancelamento voluntário, o workspace retorna ao
                plano FREE ao fim do ciclo aplicável; em caso de falha de pagamento, o acesso pode ser suspenso até a regularização.
              </p>
              <p className="mt-3">
                Regras de estorno, arrependimento e demais direitos legais aplicáveis prevalecem sobre qualquer condição comercial.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">5. Fontes externas, alertas e responsabilidade profissional</h2>
              <p>
                A disponibilidade, abrangência, formato e atualização de informações vindas de tribunais, CNJ, DataJud,
                DJEN ou outras integrações dependem dessas fontes. Por isso, o TUTO não garante cobertura universal,
                sincronização ininterrupta nem a ausência de atrasos, falhas ou divergências em dados externos.
              </p>
              <p className="mt-3">
                Um processo pode permanecer sem sincronizar quando o tribunal ainda não o publicou nas bases consultadas.
                Nesses casos o TUTO segue tentando automaticamente e indica a situação na lista de processos, mas não há
                como antecipar a publicação.
              </p>
              <p className="mt-3">
                A pesquisa de jurisprudências apresenta resultados fornecidos por provedor externo, sujeitos à cobertura e
                aos critérios dele, e está limitada à cota do seu plano. Os resultados não constituem orientação jurídica.
              </p>
              <p className="mt-3 font-medium text-[#001533]">
                O advogado e o escritório permanecem responsáveis por conferir as publicações e os prazos nos canais oficiais,
                analisar seu conteúdo e adotar as medidas profissionais cabíveis.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">6. Integrações opcionais</h2>
              <p>
                Algumas integrações dependem de uma ação sua. Ao conectar o Google Agenda, o TUTO cria e gerencia apenas
                o calendário “TUTO — Prazos e Audiências”, destinado a espelhar eventos do workspace. O TUTO não solicita
                permissão para ler ou alterar os demais calendários da conta Google. A desconexão revoga o vínculo no TUTO;
                o calendário já criado permanece na conta Google.
              </p>
              <p className="mt-3">
                Ao vincular o Telegram, você autoriza o envio dos alertas selecionados ao chat conectado. Você pode desvincular
                Google Agenda e Telegram nas configurações. O uso de serviços de terceiros também está sujeito aos termos e
                políticas desses fornecedores.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">7. Dados inseridos no TUTO</h2>
              <p>
                Você é responsável pelos dados e conteúdos incluídos no seu workspace, inclusive informações de clientes,
                partes, processos, publicações, notas, tarefas e eventos. Você deve assegurar que possui autorização e base
                legal adequadas para tratar e inserir dados pessoais de terceiros na plataforma.
              </p>
              <p className="mt-3">
                O tratamento de dados pessoais é detalhado na Política de Privacidade. Informações confidenciais são usadas
                somente para disponibilizar, proteger, manter e aprimorar os serviços, dentro dos limites da legislação aplicável.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">7.1. Financeiro e cobrança de clientes</h2>
              <p>
                O módulo Financeiro é uma ferramenta de registro e organização. Ele não substitui escrituração contábil,
                emissão de nota fiscal nem apuração de tributos, e os lançamentos não constituem documento fiscal. A
                exatidão dos valores, das datas e das baixas é de sua responsabilidade.
              </p>
              <p className="mt-3">
                Ao conectar sua conta do Asaas, o TUTO cria e consulta cobranças a seu pedido. A conta no Asaas é sua e
                a relação contratual de pagamento se estabelece entre você, o Asaas e o seu cliente — o TUTO não recebe,
                retém nem repassa valores, e não é parte nessa relação. Tarifas, prazos de liquidação, multa, juros e
                política de estorno seguem o que você contratou e configurou no Asaas.
              </p>
              <p className="mt-3">
                A baixa automática de parcelas depende de o Asaas notificar o TUTO. Falha, atraso ou indisponibilidade
                dessa comunicação pode fazer com que uma parcela paga permaneça em aberto até a próxima sincronização ou
                até a baixa manual. Confira sempre o extrato da sua conta no Asaas antes de decisões que dependam do
                recebimento.
              </p>
              <p className="mt-3">
                Você é responsável por manter em sigilo a chave de API que cadastrar e por revogá-la no Asaas caso
                suspeite de uso indevido.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">8. Uso aceitável</h2>
              <p>Não é permitido:</p>
              <ul className="mt-3 list-disc space-y-2 pl-6">
                <li>violar a lei, sigilo profissional, direitos de terceiros ou regras de acesso de fontes integradas;</li>
                <li>compartilhar credenciais, explorar contas de terceiros ou tentar contornar controles de acesso;</li>
                <li>introduzir código malicioso, realizar engenharia reversa, explorar vulnerabilidades ou sobrecarregar a infraestrutura;</li>
                <li>usar automações abusivas, extrair dados de forma não autorizada ou revender o acesso ao TUTO;</li>
                <li>inserir conteúdo ilícito, discriminatório, difamatório ou que viole direitos de terceiros.</li>
              </ul>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">9. Propriedade intelectual</h2>
              <p>
                O software, marca, interface, documentação e demais elementos do TUTO pertencem à Keep ou aos seus licenciantes.
                Enquanto sua conta estiver regular, é concedida uma licença limitada, não exclusiva, intransferível e revogável
                para usar a plataforma conforme estes Termos. Seus dados permanecem seus ou de seus respectivos titulares.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">10. Disponibilidade e limites de responsabilidade</h2>
              <p>
                Empregamos esforços razoáveis para manter o TUTO disponível e seguro, mas serviços digitais podem passar por
                manutenção, atualizações ou indisponibilidades. Na extensão permitida pela legislação aplicável, não respondemos
                por danos decorrentes exclusivamente de fontes externas, do uso indevido da plataforma, de informações incorretas
                fornecidas pelo usuário ou da ausência de conferência profissional dos prazos e atos processuais.
              </p>
              <p className="mt-3">Nada nestes Termos limita direitos que não possam ser legalmente afastados.</p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">11. Alterações e encerramento</h2>
              <p>
                Estes Termos podem ser atualizados para refletir mudanças legais, de segurança ou do serviço. A nova versão
                será publicada nesta página e, quando a alteração for relevante, comunicada por meio apropriado. O uso após a
                vigência da versão atualizada representa concordância com ela, sem prejuízo dos direitos legais aplicáveis.
              </p>
              <p className="mt-3">
                Para cancelar uma assinatura, use o portal de cobrança. Para solicitar exclusão de conta ou tratar uma questão
                sobre dados pessoais, entre em contato pelo canal indicado na Política de Privacidade.
              </p>
            </section>

            <section>
              <h2 className="mb-3 text-xl font-bold text-[#001533]">12. Lei aplicável e contato</h2>
              <p>
                Estes Termos são regidos pela legislação brasileira. Eventuais controvérsias observarão o foro competente
                previsto em lei, preservados os direitos de consumidores quando aplicáveis.
              </p>
              <div className="mt-4 border border-[#D1DEEE] bg-[#F4F7FB] p-5 text-sm leading-6">
                <p className="font-semibold text-[#001533]">Keep Soluções Tecnológicas Ltda.</p>
                <p>CNPJ 08.277.372/0001-71</p>
                <p>
                  Contato: <a href={`mailto:${CONTACT_EMAIL}`} className="font-medium text-[#003882] hover:text-[#00285e]">{CONTACT_EMAIL}</a>
                </p>
              </div>
            </section>
          </div>
        </article>
      </main>

      <footer className="mt-8 bg-[#001533] px-6 py-8 text-white">
        <div className="mx-auto flex max-w-4xl flex-col items-center justify-between gap-3 text-center text-sm md:flex-row md:text-left">
          <p className="text-[#D1DEEE]">© 2026 TUTO — Powered by Kosmos</p>
          <Link to="/politica-de-privacidade" data-testid="terms-footer-privacy-link" className="font-medium text-white hover:text-[#D1DEEE]">
            Política de Privacidade
          </Link>
        </div>
      </footer>
    </div>
  );
}